import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlusCircle } from "lucide-react";
import { ConexionAPI } from "../../lib/conexion";
import PublicacionCard from "./PublicacionCard";

export default function ConexionMisPublicaciones() {
  const [pubs, setPubs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ConexionAPI.misPublicaciones().then(setPubs).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-5" data-testid="conexion-mis-publicaciones">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <h2 className="text-2xl font-extrabold text-slate-900 tracking-tight">Mis publicaciones</h2>
          <p className="text-sm text-slate-500 mt-1">Gestiona todo lo que has publicado en ConstruLink Red.</p>
        </div>
        <Link to="/conexion/publicar" className="inline-flex items-center gap-2 bg-brand-red hover:bg-brand-red-hover text-white font-semibold text-sm px-4 py-2.5 rounded-xl shadow-sm">
          <PlusCircle size={16} /> Nueva publicación
        </Link>
      </div>

      {loading ? (
        <div className="text-center py-16 text-slate-500 text-sm">Cargando…</div>
      ) : pubs.length === 0 ? (
        <div className="bg-white rounded-2xl border border-slate-100 p-12 text-center">
          <p className="text-slate-600 font-semibold">Aún no tienes publicaciones.</p>
          <Link to="/conexion/publicar" className="mt-3 inline-block text-brand-red font-semibold hover:underline text-sm">
            Publica la primera
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {pubs.map((p) => (
            <PublicacionCard key={p.id} pub={p} />
          ))}
        </div>
      )}
    </div>
  );
}
